var path = 'src/app/patients/hospitalisations/hospitalisations.html';
var html = "<h1 class=page-header>Hospitalisations</h1> <div hospitalisations-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/hospitalisations/hospitalisations.html
 ** module id = 485
 ** module chunks = 0
 **/